﻿import Image from "../image";
import ActivePage from "../activePage";

export default class ProductPage extends ActivePage {

    constructor() {
        super();
        this.image = new Image();
    }

    onChange_RelatedProduct = (e) => {
        if (e.item) {
            const row = $(`#${e.sender.element[0].id}`).closest("tr");

            const productName = e.dataItem["ProductName"];
            console.log(productName);

            const grid = $("#prodRelatedProductsGrid").data("kendoGrid");
            const dataItem = grid.dataItem(row);
            dataItem.ProductId = e.dataItem["ProductId"];
            dataItem.ProductName = productName;

            $(row).find(".productName-field").html(productName);

        }
    }

    relatedProductsRowSave = (e) => {
        e.model.RelProductId = this.RelProductId;
        console.log(this.RelProductId);
    }

    onCountryChange = (e) => {
        pageHelper.onComboBoxChangeDisplayName(e, 'CountryName');
    }

    //TN 20221116
    onChange_BusinessUnit = (e) => {
        if (e.item) {
            const row = $(`#${e.sender.element[0].id}`).closest("tr");
            const businessUnit = e.dataItem["BusinessUnit"];
            const grid = $("#prodRelatedBusAttyGrid").data("kendoGrid");
            const dataItem = grid.dataItem(row);
            dataItem.BusinessUnitID = e.dataItem["BusinessUnitID"];
            dataItem.BusinessUnitName = businessUnit;
        }
    }
    onChange_Attorney = (e) => {
        if (e.item) {
            const row = $(`#${e.sender.element[0].id}`).closest("tr");
            const attorney = e.dataItem["AttorneyCode"];
            const grid = $("#prodRelatedBusAttyGrid").data("kendoGrid");
            const dataItem = grid.dataItem(row);
            dataItem.AttorneyID = e.dataItem["AttorneyID"];
            dataItem.AttorneyName = attorney;
        }
    }
    onChange_Client = (e) => {
        if (e.item) {
            const row = $(`#${e.sender.element[0].id}`).closest("tr");
            const client = e.dataItem["ClientCode"];
            const grid = $("#prodRelatedBusAttyGrid").data("kendoGrid");
            const dataItem = grid.dataItem(row);
            dataItem.ClientID = e.dataItem["ClientID"];
            dataItem.ClientName = client;
        }
    }
    //TN 20221116
}
